import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { TimePicker } from '@mui/x-date-pickers/TimePicker'
import dayjs, { Dayjs } from 'dayjs'
import { useEffect, useState } from 'react'
import 'dayjs/locale/hu'

type TimePickerProps = {
  value: string | Dayjs | null
  onChange: (value: any | null) => void
}

export function CustomTimePicker({ value, onChange }: TimePickerProps) {
  const [time, setTime] = useState<Dayjs | null>(null)

  useEffect(() => {
    if (typeof value === 'string' && value.length < 6) {
      const parsed = dayjs(value, 'HH:mm')
      setTime(parsed.isValid() ? parsed : null)
    } else if (dayjs.isDayjs(value)) {
      setTime(value)
    } else if (value) {
      const parsed = dayjs(value)
      setTime(parsed.isValid() ? parsed : null)
    } else {
      setTime(null)
    }
  }, [value])

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="hu">
      <TimePicker value={time} onChange={onChange} />
    </LocalizationProvider>
  )
}
